import _classCallCheck from "C:\\Sasria_digital\\PE_REL\\PE_Claims\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Sasria_digital\\PE_REL\\PE_Claims\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _inherits from "C:\\Sasria_digital\\PE_REL\\PE_Claims\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "C:\\Sasria_digital\\PE_REL\\PE_Claims\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\Sasria_digital\\PE_REL\\PE_Claims\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { isArray } from 'vega-util';
import { some } from '../../util';
import { Split } from '../split';
export var ScaleComponent = /*#__PURE__*/function (_Split) {
  _inherits(ScaleComponent, _Split);

  var _super = _createSuper(ScaleComponent);

  function ScaleComponent(name, typeWithExplicit) {
    var _this;

    _classCallCheck(this, ScaleComponent);

    _this = _super.call(this, {}, // no initial explicit property
    {
      name: name
    } // name as initial implicit property
    );
    _this.merged = false;

    _this.setWithExplicit('type', typeWithExplicit);

    return _this;
  }
  /**
   * Whether the scale definitely includes zero in the domain
   */


  _createClass(ScaleComponent, [{
    key: "domainDefinitelyIncludesZero",
    value: function domainDefinitelyIncludesZero() {
      if (this.get('zero') !== false) {
        return true;
      }

      return some(this.get('domains'), function (d) {
        return isArray(d) && d.length === 2 && d[0] <= 0 && d[1] >= 0;
      });
    }
  }]);

  return ScaleComponent;
}(Split);